import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  bookSize: {
    id: 'BookSizeSelector.bookSize',
    defaultMessage: 'Select the size of book',
  },
  'large-square': {
    id: 'BookSizeSelector.large-square',
    defaultMessage: 'Large Square Book 12x12',
  },
  'medium-square': {
    id: 'BookSizeSelector.medium-square',
    defaultMessage: 'Medium Square Book 10x10',
  },
  'small-square': {
    id: 'BookSizeSelector.small-square',
    defaultMessage: 'Small Square Book 8.5x8.5',
  },
  'large-rectangle': {
    id: 'BookSizeSelector.large-rectangle',
    defaultMessage: 'Large Rectangle Book 14x11',
  },
  'medium-rectangle': {
    id: 'BookSizeSelector.medium-rectangle',
    defaultMessage: 'Medium Rectangle Book 12.5x10',
  },
  'small-rectangle': {
    id: 'BookSizeSelector.small-rectangle',
    defaultMessage: 'Small Rectangle Book 11x8.5',
  },
  'xsmall-rectangle': {
    id: 'BookSizeSelector.xsmall-rectangle',
    defaultMessage: 'Extra Small Rectangle Book 9x7',
  },
})
